import Image from 'next/image';
import iPhoneMockUpLoadBoardPng from './iphone-mockup-load-board.png';
import DallasImageProps from '../dallas-image-props';

export default function DallasImageiPhoneMockUpLoadBoard(
  props: DallasImageProps,
) {
  return (
    <Image
      {...props}
      src={iPhoneMockUpLoadBoardPng}
      alt="TruckSmarter's Free Load Board App on iPhone"
    />
  );
}
